module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/mermaid-5c64c2d607b75968336851e627ffdde3.jpg";